module.exports = {
	"_args": [
		[
			{
				"raw": "axios@^0.15.3",
				"scope": null,
				"escapedName": "axios",
				"name": "axios",
				"rawSpec": "^0.15.3",
				"spec": ">=0.15.3 <0.16.0",
				"type": "range"
			},
			"/Users/bryanbrophy/HighSeas/paragon/paragon-dash-api-client"
		]
	],
	"_from": "axios@>=0.15.3 <0.16.0",
	"_id": "axios@0.15.3",
	"_inCache": true,
	"_location": "/axios",
	"_nodeVersion": "7.0.0",
	"_npmOperationalInternal": {
		"host": "packages-18-east.internal.npmjs.com",
		"tmp": "tmp/axios-0.15.3.tgz_1480283949051_0.7373273745179176"
	},
	"_npmUser": {
		"name": "nickuraltsev",
		"email": "nick.uraltsev@gmail.com"
	},
	"_npmVersion": "3.10.8",
	"_phantomChildren": {},
	"_requested": {
		"raw": "axios@^0.15.3",
		"scope": null,
		"escapedName": "axios",
		"name": "axios",
		"rawSpec": "^0.15.3",
		"spec": ">=0.15.3 <0.16.0",
		"type": "range"
	},
	"_requiredBy": [
		"/"
	],
	"_resolved": "https://registry.npmjs.org/axios/-/axios-0.15.3.tgz",
	"_shasum": "2c9d638b2e191a08ea1d6cc988eadd6ba5bdc053",
	"_shrinkwrap": null,
	"_spec": "axios@^0.15.3",
	"_where": "/Users/bryanbrophy/HighSeas/paragon/paragon-dash-api-client",
	"author": {
		"name": "Matt Zabriskie"
	},
	"browser": {
		"./lib/adapters/http.js": "./lib/adapters/xhr.js"
	},
	"bugs": {
		"url": "https://github.com/mzabriskie/axios/issues"
	},
	"dependencies": {
		"follow-redirects": "1.0.0"
	},
	"description": "Promise based HTTP client for the browser and node.js",
	"devDependencies": {
		"coveralls": "^2.11.9",
		"es6-promise": "^4.0.5",
		"grunt": "^1.0.1",
		"grunt-banner": "^0.6.0",
		"grunt-cli": "^1.2.0",
		"grunt-contrib-clean": "^1.0.0",
		"grunt-contrib-nodeunit": "^1.0.0",
		"grunt-contrib-watch": "^1.0.0",
		"grunt-eslint": "^19.0.0",
		"grunt-karma": "^2.0.0",
		"grunt-ts": "^6.0.0-beta.3",
		"grunt-typings": "^0.1.5",
		"grunt-webpack": "^1.0.18",
		"istanbul-instrumenter-loader": "^1.0.0",
		"jasmine-core": "^2.4.1",
		"karma": "^1.3.0",
		"karma-chrome-launcher": "^2.0.0",
		"karma-coverage": "^1.0.0",
		"karma-firefox-launcher": "^1.0.0",
		"karma-jasmine": "^1.0.2",
		"karma-jasmine-ajax": "^0.1.13",
		"karma-opera-launcher": "^1.0.0",
		"karma-phantomjs-launcher": "^1.0.0",
		"karma-safari-launcher": "^1.0.0",
		"karma-sauce-launcher": "^1.1.0",
		"karma-sinon": "^1.0.5",
		"karma-sourcemap-loader": "^0.3.7",
		"karma-webpack": "^1.7.0",
		"load-grunt-tasks": "^3.5.2",
		"minimist": "^1.2.0",
		"phantomjs-prebuilt": "^2.1.7",
		"sinon": "^1.17.4",
		"typescript": "^2.0.3",
		"url-search-params": "^0.6.1",
		"webpack": "^1.13.1",
		"webpack-dev-server": "^1.14.1"
	},
	"directories": {},
	"dist": {
		"shasum": "2c9d638b2e191a08ea1d6cc988eadd6ba5bdc053",
		"tarball": "https://registry.npmjs.org/axios/-/axios-0.15.3.tgz"
	},
	"gitHead": "4976816808c4e81acad2393c429832afeaf9664d",
	"homepage": "https://github.com/mzabriskie/axios",
	"keywords": [
		"xhr",
		"http",
		"ajax",
		"promise",
		"node"
	],
	"license": "MIT",
	"main": "index.js",
	"maintainers": [
		{
			"name": "mzabriskie",
			"email": "mzabriskie@gmail.com"
		},
		{
			"name": "nickuraltsev",
			"email": "nick.uraltsev@gmail.com"
		}
	],
	"name": "axios",
	"optionalDependencies": {},
	"readme": "ERROR: No README data found!",
	"repository": {
		"type": "git",
		"url": "git+https://github.com/mzabriskie/axios.git"
	},
	"scripts": {
		"build": "NODE_ENV=production grunt build",
		"coveralls": "cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js",
		"examples": "node ./examples/server.js",
		"postversion": "git push && git push --tags",
		"preversion": "npm test",
		"start": "node ./sandbox/server.js",
		"test": "grunt test",
		"version": "npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json"
	},
	"typings": "./index.d.ts",
	"version": "0.15.3"
};


//////////////////
// WEBPACK FOOTER
// ./~/axios/package.json
// module id = 41
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///~/axios/package.json